import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { ComponentBase, DbaDataTableColumn, DialogData, Mandant, MandantAuthService } from '@definitiv-packages/angular-dba-library';

import { AppService, DebitorModel, DebitorService, ObjektModelView, ObjektService, ObjektViewService, 
  ProjectLanguage, ProjektPermissionService, SafetyPointFormModelViewService, SafetypointPDFService, SafetyPointViewService, StandortModel, StandortService } from '../../../../../roofsafetymanagement-library/src/public-api';

import { CreateObjektComponent } from '../../../../../roofsafetymanagement-library/src/lib/dialogs/create-objekt/create-objekt.component';
import { CompletedFormDto, CompletedFormDtoService, FormDtoService, FormViewService } from '@definitiv-packages/angular-forms-library';
import { PDFDocument } from 'pdf-lib';
@Component({
  selector: 'app-objekt-main-view',
  templateUrl: './objekt-main-view.component.html',
  styleUrls: ['./objekt-main-view.component.scss'],
  standalone: false
})
export class ObjektMainViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public importing: boolean = false;
  public isAdmin: boolean = false;
  public isAppAdmin: boolean = false;

  public objektList: ObjektModelView[] = [];
  public selectedObjekt: ObjektModelView | null = null;

  public debitorList: DebitorModel[] = [];
  public standortList: StandortModel[] = [];
  public debitorfilteredList: DebitorModel[] = [];
  public standortfilteredList: StandortModel[] = [];  

  public selectedDebitor: DebitorModel = new DebitorModel();
  public selectedStandort: StandortModel = new StandortModel();
  public currentMandant: Mandant = new Mandant();
  public columnsdefMain: DbaDataTableColumn<ObjektModelView, ProjectLanguage>[] = [
    { id: 'Bezeichnung', label: 'Bezeichnung', hideOrder: 0 },
    { id: 'Strasse', label: 'Strasse', hideOrder: 1 },
    { id: 'PLZ', label: 'PLZ', hideOrder: 2, width: 100 },
    { id: 'Ort', label: 'Ort', hideOrder: 3 },
    { id: 'LandName', label: 'Land', hideOrder: 4 },
    { id: 'DebitorNummer', label: 'debitornr', hideOrder: 5, width: 100 },
    { id: 'DebitorName', label: 'debitorname', hideOrder: 6 },
    { id: 'StandortBezeichnung', label: 'Standort', hideOrder: 6 },
  ];

  constructor(
    public permissionService  : ProjektPermissionService,
    private objektViewService : ObjektViewService,
    private objektService     : ObjektService,
    private formViewService : FormViewService,
    private debitorService: DebitorService,
    private standortService: StandortService,
    private formDtoService: FormDtoService,
    private safetyPointViewService: SafetyPointViewService,
    private safetyPointFormModelViewService: SafetyPointFormModelViewService,
    private mandantService: MandantAuthService,
    private completedFormDtoService: CompletedFormDtoService,
    private safetypointPDFService: SafetypointPDFService,
    private appService: AppService,
    private dialog: MatDialog,
  ) { super(); }

  public async ngOnInit() {
    this.isAdmin = this.appService.isUserAdmin();
    this.isAppAdmin = this.appService.isAppAdmin();
    this.loading = true;

    await this.getDebitorList();
    await this.getStandortList();
    await this.getObjektList();
    this.loading = false;
  }

  public async getObjektList() {
    try {
      var result = await Promise.all([this.objektViewService.getList(), this.mandantService.GetCurrentMandant()]);
      
      this.objektList = result[0];
      this.currentMandant = result[1];
    } catch {}    
  };

  public async getDebitorList() {
    try {
      var result = await Promise.all([this.debitorService.getList()]);

      this.debitorList = result[0].sort((a, b) =>
        (a.Name || '').localeCompare(b.Name || '')
      );
    } catch {
    }

    var alledebitor = new DebitorModel();
    alledebitor.DebitorID = 0;
    alledebitor.Name = "alle";

    this.debitorList.unshift(alledebitor);
    this.selectedDebitor = this.debitorList[0];
    this.debitorfilteredList = this.debitorList;
  }

    public async getStandortList() {
    try {
      var result = await Promise.all([this.standortService.getList()]);

      this.standortList = result[0].sort((a, b) =>
        (a.Bezeichnung || '').localeCompare(b.Bezeichnung || '')
      );
    } catch {
    }

    var allestandort = new StandortModel();
    allestandort.StandortID = 0;
    allestandort.Bezeichnung = "alle";

    this.standortList.unshift(allestandort);
    this.selectedStandort = this.standortList[0];
    this.standortfilteredList = this.standortList;
  }

  // public DeleteDataMain(selected: (Personal | null)[]): void {
  //   BuildDeleteDataPromise<Personal | null>(selected, (element) => { return this.PersonalService.DeletePersonal(element!) }).then(() => this.getPersonalList());
  // };


  public async OpenDialog(data: DialogData<ObjektModelView>): Promise<void> {
    if (!this.permissionService.ObjektSchreiben) return;

    var objekt = await firstValueFrom(this.dialog.open(CreateObjektComponent, { data: data }).afterClosed());

    if (!objekt)
      return

    var changedobjekt = await this.objektViewService.get(objekt.ObjektID)

    this.selectedObjekt = null;

    if (data.mode == 'create' || data.mode == 'copy')
      this.objektList.push(changedobjekt);
    else if (data.mode == 'edit') {
      var index = this.objektList.findIndex(x => x.ObjektID == objekt.ObjektID);
      if (index != -1)
        this.objektList[index] = changedobjekt;
    }

    this.selectedObjekt = changedobjekt;
  }



    public debitorFilter = (list: ObjektModelView[], filter: DebitorModel): ObjektModelView[] => {
      if (filter.DebitorID == undefined || filter.DebitorID == 0){
          this.standortfilteredList = this.standortList;       
          return list;
      }else{                       
            return list.filter(x => x.DebitorID == filter.DebitorID);
      }
    }
    public standortFilter = (list: ObjektModelView[], filter: StandortModel): ObjektModelView[] => {
      if (filter.StandortID == undefined || filter.StandortID == 0){
        return list;
      }
      return list.filter(x => x.StandortID == filter.StandortID);
    }    
    public filtersstandort() {

      if(this.selectedDebitor.DebitorID== 0){
          this.standortfilteredList = this.standortList;
      }else{
          this.standortfilteredList = this.standortList.filter(x=>x.DebitorID == this.selectedDebitor.DebitorID || x.DebitorID==0);
      }
     
    }

    async deleteData(objekt: ObjektModelView[]) {
        this.loading = true;
        
        await this.objektService.delete(objekt[0].ObjektID!);
        await this.getObjektList();
        this.loading = false;
    }  

    public async Berichtdrucken(objekt: ObjektModelView){

        this.loading = true;
        var resultList = await Promise.all([
            this.safetyPointViewService.getFilteredList({ObjektID: objekt.ObjektID}),
            this.formViewService.getList(),
            this.safetyPointFormModelViewService.getFilteredList({ObjektID:objekt.ObjektID})
        ])

        var safetypoints = resultList[0];
        var forms = resultList[1];  
        var safetypointformList = resultList[2];
        
        var completdForms :CompletedFormDto[] = []
        var formfelderlist =  []

        for(var j=0; j<safetypointformList.length;j++){
            
            var completedform  = await this.completedFormDtoService.get(safetypointformList[j].CompletedFormId);
            completdForms.push(completedform)
        }

        for (var m=0;m<forms.length;m++){

            var form = await this.formDtoService.get(forms[m].FormId);
            formfelderlist.push(form.StepList.flatMap(x=>x.FieldList))
        }

        var strings = [];
        for(let i =0; i<safetypoints.length; i++){

            let safetypoint = safetypoints[i];
            formfelderlist = formfelderlist.flat();                  
            var result = await this.safetypointPDFService.generateAuditsPDF(safetypoint,safetypointformList.filter(x=>x.SafetyPointId ==safetypoint.SafetyPointId ),this.currentMandant,completdForms, formfelderlist);
            
            strings.push(result); 
        }

        const mergedPdf = await PDFDocument.create();

        for (const base64 of strings) {
            const bytes = Uint8Array.from(
              atob(base64.replace(/^data:application\/pdf;base64,/, '')),
              c => c.charCodeAt(0)
            );
            
            const pdf = await PDFDocument.load(bytes);
            const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());

            pages.forEach(page => mergedPdf.addPage(page));
          }
          const mergedBytes = await mergedPdf.save();

              const blob = new Blob([new Uint8Array(mergedBytes)], {
            type: "application/pdf",
          });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'merged.pdf';
            a.click();

            URL.revokeObjectURL(url);       
            
            this.loading = false;

    }

}
